module.exports = __webpack_public_path__ + "img/bluevert.8e50780f.png";